import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './analyzer.css';

function CopyButton({ text }) {
    const copy = () => navigator.clipboard.writeText(text);
    return (
      <button 
        onClick={copy}
        className="absolute top-2 right-2 text-sm bg-shi-green text-white px-2 py-1 rounded">
        Copy
      </button>
    );
  }

const MarkdownRenderer = ({ content }) => (

      <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        // 1. This handles any ```objection … ``` block
        code({ node, inline, className = '', children, ...props }) {
          const isObjection = /language-objection/.test(className);
          const text = String(children).trim();
          if (!inline && isObjection) {
            return (
              <div className="relative bg-gray-100 p-4 rounded-lg my-4">
                <CopyButton text={text} />
                <pre className="whitespace-pre-wrap text-sm" {...props}>
                  {text}
                </pre>
              </div>
            );
          }
          // fallback for other inline or code blocks
          return (
            <code
              className={className}
              style={{
                backgroundColor: '#f0f0f0',
                padding: '0.2em 0.4em',
                borderRadius: '4px',
              }}
              {...props}
            >
              {children}
            </code>
          );
        },
  
        // headings
        h1: ({node, ...props}) => (
          <h1 className="text-[24px] text-[#004225] mb-4 flex items-center">
            <span role="img" aria-label="sparkles">✨</span>&nbsp;
            <span {...props} />
          </h1>
        ),
        h2: ({node, ...props}) => (
          <h2 className="text-[20px] text-[#004225] mb-3 flex items-center">
            <span role="img" aria-label="dart">🎯</span>&nbsp;
            <span {...props} />
          </h2>
        ),
  
        // paragraphs
        p: ({node, ...props}) => <p className="mb-2 leading-relaxed" {...props} />,
  
        // lists
        ul: ({node, ...props}) => <ul className="list-disc ml-6 mb-4" {...props} />,
        ol: ({node, ...props}) => <ol className="list-decimal ml-6 mb-4" {...props} />,
        li: ({node, ...props}) => <li className="mb-1" {...props} />,
  
        // strong text
        strong: ({node, ...props}) => (
          <strong className="font-semibold text-[#004225]" {...props} />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
  
  export default MarkdownRenderer;